import { useSelector } from 'react-redux';

const useCanValidateStoreReception = (): boolean => {
  const { user } = useSelector((state: any) => state.user);

  return user?.permission?.validateStoreReception?.canMutate === true;
};

export default useCanValidateStoreReception;
